import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideEntrepriseStub } from '../../../../config/aides-entreprises';

export default function SuramortissementPage() {
  const aide = getAideEntrepriseStub('suramortissement');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="entreprises" />;
}
